import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, authHeaders, errorText } from "@/lib/api";
import { CrmCells } from "./AdminCrm";

export const ToolkitTable = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    axios.get(`${API}/admin/toolkit-leads`, { headers: authHeaders() })
      .then((r) => setRows(Array.isArray(r.data) ? r.data : []))
      .catch((e) => toast.error(errorText(e)));
  }, []);
  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
      <table data-testid="admin-toolkit-table" className="w-full min-w-[1150px] text-left text-[14px]">
        <thead className="bg-slate-50 text-[12px] uppercase tracking-wider text-slate-600">
          <tr>{["Date", "Lead", "Role", "Experience", "Goal", "Updates", "Emails", "Status", "Notes"].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {rows.map((r) => (
            <tr key={r.id} data-testid="admin-toolkit-row">
              <td className="px-4 py-3 text-slate-600">{new Date(r.created_at).toLocaleString()}</td>
              <td className="px-4 py-3"><p className="font-semibold text-[#0B1B33]">{r.name}</p><p className="text-slate-600">{r.email}</p></td>
              <td className="px-4 py-3">{r.role}</td>
              <td className="px-4 py-3">{r.years}</td>
              <td className="px-4 py-3">{r.goal}</td>
              <td className="px-4 py-3">{r.consent_marketing ? "Yes" : "No"}</td>
              <td className="px-4 py-3 text-[12px] text-slate-600">User: {r.user_email}<br />Admin: {r.admin_email}</td>
              <CrmCells email={r.email} name={r.name} />
            </tr>
          ))}
          {!rows.length && <tr><td colSpan={9} className="px-4 py-12 text-center text-slate-600">No toolkit sign-ups yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
};
